import { AuthLoginResponse } from '@afterpaytouch/portal-api/consumer/auth/types'

const USER_STORAGE_KEY = 'portal_user_hash'
const EXPIRATION_TIME = 60 * 59 * 1000
const generateHash = (id: number, timestamp: number): string => {
  const data = `${id}-${timestamp}-portal-user`
  let hash = 0
  for (let i = 0; i < data.length; i++) {
    const char = data.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return hash.toString(36)
}

export const setUserStorageHint = (userId: number): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const timestamp = Date.now()
    const hash = generateHash(userId, timestamp)

    const storageData = {
      hash,
      timestamp,
    }
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(storageData))
  } catch (error) {
    console.warn('Failed to store user data in localStorage:', error)
  }
}

export const setUserInStorage = (result: AuthLoginResponse): void => {
  setUserStorageHint(result.user.id)
}

export const getUserFromStorage = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const stored = localStorage.getItem(USER_STORAGE_KEY)
    if (!stored) {
      return null
    }

    const storageData = JSON.parse(stored)

    if (!storageData || typeof storageData.hash !== 'string' || typeof storageData.timestamp !== 'number') {
      console.warn('Invalid user data structure in localStorage')
      localStorage.removeItem(USER_STORAGE_KEY)
      return null
    }

    const now = Date.now()
    if (now - storageData.timestamp > EXPIRATION_TIME) {
      console.info('User data expired, clearing from localStorage')
      localStorage.removeItem(USER_STORAGE_KEY)
      return null
    }

    return storageData.hash
  } catch (error) {
    console.warn('Failed to retrieve user data from localStorage:', error)
    localStorage.removeItem(USER_STORAGE_KEY)
    return null
  }
}

export const clearUserFromStorage = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.removeItem(USER_STORAGE_KEY)
  } catch (error) {
    console.warn('Failed to clear user data from localStorage:', error)
  }
}
